const isObjectLike = value => "object" == typeof value && null !== value;

export default isObjectLike;
//# sourceMappingURL=isObjectLike.js.map